const DV_WEIGHTS_STEP_ONE = [5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2];
const DV_WEIGHTS_STEP_TWO = [6, 5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2];
const CNPJ_LENGTH = 14;

export function sanitizeDocument(value: string): string {
  return (value || '').replace(/[^A-Za-z0-9]/g, '').toUpperCase();
}

function isStructuralValid(clean: string): boolean {
  return /^[A-Z0-9]{12}\d{2}$/.test(clean);
}

function hasInvalidRepetition(clean: string): boolean {
  return /^([A-Z0-9])\1{13}$/.test(clean);
}

function charToValue(char: string): number {
  return char.charCodeAt(0) - 48;
}

function calculateDigit(sequence: string, weights: number[]): number {
  let sum = 0;
  for (let i = 0; i < weights.length; i++) {
    const value = charToValue(sequence[i]);
    if (isNaN(value)) {
      return NaN;
    }
    sum += value * weights[i];
  }
  const mod = sum % 11;
  return mod < 2 ? 0 : 11 - mod;
}

export function validateExtendedCnpj(value: string): boolean {
  const clean = sanitizeDocument(value);
  if (clean.length !== CNPJ_LENGTH) {
    return false;
  }
  if (!isStructuralValid(clean) || hasInvalidRepetition(clean)) {
    return false;
  }
  const base = clean.substring(0, 12);
  const firstDigit = calculateDigit(base, DV_WEIGHTS_STEP_ONE);
  if (isNaN(firstDigit)) {
    return false;
  }
  const secondDigit = calculateDigit(base + firstDigit.toString(), DV_WEIGHTS_STEP_TWO);
  if (isNaN(secondDigit)) {
    return false;
  }
  return clean.endsWith(`${firstDigit}${secondDigit}`);
}
